import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {MerchantInfo} from '@aboutyou/ui-components';
import React, {useState} from 'react';
import {MerchantLegalInfo} from '../MerchantLegalInfo/MerchantLegalInfo';

interface MerchantInfoWithLegalProps {
  availability: SizeSelection_Size['availability'];
  className?: string;
  showBorderRadius?: boolean;
  productId: number;
  sizeId: number;
}

export const MerchantInfoWithLegal = ({
  availability,
  className,
  showBorderRadius,
  productId,
  sizeId,
}: MerchantInfoWithLegalProps) => {
  const [showLegalModal, setShowLegalModal] = useState(false);

  const onInfoClick = () => {
    setShowLegalModal(true);
  };

  const onLegalInfoClose = () => {
    setShowLegalModal(false);
  };

  if (
    !availability ||
    availability?.$case === 'soldOut' ||
    !availability.inStock.merchantInfo
  ) {
    return null;
  }

  return (
    <>
      <MerchantInfo
        rows={availability.inStock.merchantInfo.rows.map(row => row.text.text)}
        className={className}
        showBorderRadius={showBorderRadius}
        onInfoClick={onInfoClick}
      />
      {showLegalModal && (
        <MerchantLegalInfo
          productId={productId}
          sizeId={sizeId}
          onClose={onLegalInfoClose}
        />
      )}
    </>
  );
};
